import React from 'react';

import { InPlay as EventsInPlay } from 'src/domains/sportsbook/webview/components/containers/eventsInPlay/EventsInPlay';
import { observer } from 'src/utils/mobx-react';
import { EventsInPlayWrapper, InPlayHeader, Sport } from './InPlayPage.style';
import { EventsUpcoming } from 'src/domains/sportsbook/webview/components/containers/eventsUpcoming/EventsUpcoming';
import { LayoutSkeleton } from 'src/domains/layouts/webview/modules/LayoutSkeleton';
import { InPlayRouteType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import { PromotedEventsWidget } from 'src/domains/sportsbook/webview/components/containers/promotedEvents/PromotedEventsWidget';
import { RightHandSideViewType } from 'src/domains/layouts/state/router/newRouter/rhsRouteType';
import { SeoPagesContent } from 'src/domains/layouts/webview/components/seoPages/SeoPages';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { EventsCollectionState } from 'src/domains/sportsbook/state/eventsCollection/EventsCollectionState';

//TODO: I have not removed it can be useful
//const NoEvents = observer(() => (
//    <div className="no-events">
//        <header className="no-events__header">
//            <img src={INPLAY_NO_EVENTS} className="header__icon"/>
//            <h1 className="header__title">
//                <I18n langKey="layouts.in-play.empty.header" defaultText="SORRY!" />
//            </h1>
//            <div className="header__text">
//                <p>
//                    <I18n langKey="layouts.in-play.empty.description.line-1" defaultText="There are no in-play events happening right now. Please check back later." />
//                </p>
//                <p>
//                    <I18n langKey="layouts.in-play.empty.description.line-2" defaultText="In the meantime check out up and coming events below!" />
//                </p>
//            </div>
//        </header>
//        <EventsOnLater />
//    </div>
//));

const EventsInPlayContent = observer('EventsInPlayContent', () => {
    const common = useCommon();
    const eventsCollection = EventsCollectionState.get(common);
    const inPlayCollection = eventsCollection.listInPlay;
    const inPlayIsLoading = inPlayCollection.isLoading;
    const noEvents = inPlayIsLoading === false && inPlayCollection.total === 0;

    if (noEvents) {
        return (
            <>
                <EventsUpcoming
                    showPriceLegend={true}
                    isLoading={false}
                />
                <PromotedEventsWidget />
            </>
        );
    }

    return (
        <EventsInPlay
            showPriceLegend={true}
            isLoading={inPlayIsLoading}
        />
    );
});

interface PropsType {
    currentView: InPlayRouteType;
    isSearchActive: boolean;
    accountView: RightHandSideViewType | null;
}

export const InPlayLayout = observer('InPlayLayout', ({ currentView, accountView, isSearchActive }: PropsType) => {
    const common = useCommon();
    const {
        componentVariants: { sportsbookVariant },
    } = ConfigComponents.get(common).unifiedComponentConfig;

    return (
        <Sport>
            <LayoutSkeleton
                currentView={currentView}
                accountView={accountView}
                isSearchActive={isSearchActive}
                navigationType='global'
            >
                <EventsInPlayWrapper
                    variant={sportsbookVariant}
                    className='in-play-page'
                >
                    <div className='in-play-page-general'>
                        <InPlayHeader variant={sportsbookVariant}>In Play</InPlayHeader>
                        <EventsInPlayContent />
                    </div>
                    <SeoPagesContent pageSlug='inplay' />
                </EventsInPlayWrapper>
            </LayoutSkeleton>
        </Sport>
    );
});
